export default function formatDistance(distance) {
    return !isNaN(parseFloat(distance))
        ? String(parseFloat(distance)
            .toFixed(1))
            .replace(/\.0+$/, '')
        : distance;
};
